export const OPTIONS_TYPE = [
  { value: "lsfhp", label: "บัญชี 1" },
  { value: "vsfhp", label: "บัญชี 2" },
  { value: "sfhp", label: "บัญชี 8" },
  { value: "rpsl", label: "P-LOAN" },
  { value: "psfhp", label: "บัญชี 3(เก่า)" },
];
